import styled, { css } from '@xstyled/styled-components'

export const ProductMain = styled.div`
  background-color: var(--white);
`

export const ProductInner = styled.div`
  ${({ theme }) => css`
    margin: 0 auto;
    width: 100%;
    padding: 4rem 2rem;
    display: block;
    min-height: 90vh;

    ${theme.mediaQueries.desktop} {
      padding: calc(${theme.navHeight} + ${theme.space[9]}px) 8 6;
      display: flex;
      max-width: 1440px;
    }
  `}
`
